import { render, staticRenderFns } from "./VehicleRequirementsInput.vue?vue&type=template&id=6808d2e6&"
import script from "./VehicleRequirementsInput.vue?vue&type=script&lang=js&"
export * from "./VehicleRequirementsInput.vue?vue&type=script&lang=js&"
import style0 from "./VehicleRequirementsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports